import {
	Basketball,
	Camera,
	MagicWand,
	MusicNote,
	NFTspacew,
	PaintBrush,
	Planet,
	Swatches,
	VideoCamera,
	WalletBg,
	aniCol1,
	aniCol2,
	aniCol3,
	cat1,
	cat2,
	cat3,
	cat4,
	cat5,
	cat6,
	cat7,
	cat8,
	disCol1,
	disCol2,
	disCol3,
	mushCol1,
	mushCol2,
	mushCol3,
	nft1,
	nft10,
	nft11,
	nft12,
	nft13,
	nft14,
	nft15,
	nft16,
	nft17,
	nft18,
	nft19,
	nft2,
	nft20,
	nft21,
	nft22,
	nft23,
	nft24,
	nft25,
	nft26,
	nft27,
	nft3,
	nft4,
	nft5,
	nft6,
	nft7,
	nft8,
	nft9,
} from "../assets";
import artists from "./artists";

const nftData = [
	{
		name: "Space Walking",
		img: NFTspacew,
		artist: artists[9],
		price: 1.03,
		highestBid: 5.33,
	},
	{
		name: "Distant Galaxy",
		img: nft1,
		artist: artists[3],
		price: 1.63,
		highestBid: 0.33,
	},
	{
		name: "Life on Edena",
		img: nft2,
		artist: artists[18],
		price: 2.13,
		highestBid: 0.76,
	},
	{
		name: "AstroFiction",
		img: nft3,
		artist: artists[10],
		price: 1.64,
		highestBid: 2.33,
	},
	{
		name: "Colorful Dog 0520",
		img: aniCol1,
		artist: artists[5],
		price: 1.68,
		highestBid: 2.33,
	},
	{
		name: "Disco Catx",
		img: aniCol2,
		artist: artists[12],
		price: 1.18,
		highestBid: 2.13,
	},
	{
		name: "B with G",
		img: aniCol3,
		artist: artists[14],
		price: 1.88,
		highestBid: 7.13,
	},
	{
		name: "Dancing Robot 0345",
		img: disCol1,
		artist: artists[6],
		price: 2.88,
		highestBid: 4.13,
	},
	{
		name: "Dancing Robot 0342",
		img: disCol2,
		artist: artists[17],
		price: 2.88,
		highestBid: 4.13,
	},
	{
		name: "Dancing Robot 0245",
		img: disCol3,
		artist: artists[19],
		price: 2.88,
		highestBid: 4.13,
	},
	{
		name: "Magic Mashroom 0299",
		img: mushCol1,
		artist: artists[6],
		price: 5.48,
		highestBid: 3.58,
	},
	{
		name: "Magic Mashroom 0234",
		img: mushCol2,
		artist: artists[6],
		price: 5.48,
		highestBid: 3.58,
	},
	{
		name: "Magic Mashroom 0129",
		img: mushCol3,
		artist: artists[6],
		price: 5.48,
		highestBid: 3.58,
	},
	{
		name: "CryptoCity",
		img: nft4,
		artist: artists[19],
		price: 12.48,
		highestBid: 9.58,
	},
	{
		name: "ColorfulDog 0986",
		img: nft5,
		artist: artists[0],
		price: 42.48,
		highestBid: 19.58,
	},
	{
		name: "Space Tales",
		img: nft6,
		artist: artists[2],
		price: 3.35,
		highestBid: 2.58,
	},
	{
		name: "Cherry Blossom Girl 238",
		img: nft7,
		artist: artists[4],
		price: 14.35,
		highestBid: 12.58,
	},
	{
		name: "Dancing Robot 235",
		img: nft8,
		artist: artists[1],
		price: 44.35,
		highestBid: 20.58,
	},
	{
		name: "Ice Cream Ape",
		img: nft9,
		artist: artists[11],
		price: 5.95,
		highestBid: 3.58,
	},
	{
		name: "FoxyLife",
		img: nft10,
		artist: artists[13],
		price: 19.95,
		highestBid: 16.18,
	},
	{
		name: "Cat From Future",
		img: nft11,
		artist: artists[15],
		price: 7.8,
		highestBid: 2.27,
	},
	{
		name: "Psycho Dog",
		img: aniCol1,
		artist: artists[17],
		price: 12.55,
		highestBid: 9.28,
	},
	{
		name: "Designer Bear",
		img: nft12,
		artist: artists[19],
		price: 2.45,
		highestBid: 8.18,
	},
	{
		name: "Dancing Robot 339",
		img: nft13,
		artist: artists[18],
		price: 3.55,
		highestBid: 1.28,
	},
	{
		name: "Dancing Robot 344",
		img: nft14,
		artist: artists[16],
		price: 12.55,
		highestBid: 9.28,
	},
	{
		name: "Dancing Robot 314",
		img: nft15,
		artist: artists[14],
		price: 12.55,
		highestBid: 9.28,
	},
	{
		name: "Dancing Robot 394",
		img: nft16,
		artist: artists[12],
		price: 12.55,
		highestBid: 9.28,
	},
	{
		name: "Happy Robot 001",
		img: nft17,
		artist: artists[10],
		price: 15.23,
		highestBid: 14.11,
	},
	{
		name: "Happy Robot 011",
		img: nft18,
		artist: artists[8],
		price: 11.21,
		highestBid: 6.21,
	},
	{
		name: "Designer Bear 011",
		img: nft19,
		artist: artists[6],
		price: 7.21,
		highestBid: 5.01,
	},
	{
		name: "ColorfuDog 0234",
		img: nft20,
		artist: artists[4],
		price: 21.21,
		highestBid: 3.21,
	},
	{
		name: "Dancing Robot 095",
		img: nft21,
		artist: artists[2],
		price: 11.21,
		highestBid: 6.21,
	},
	{
		name: "Cherry Blossom Girl 445",
		img: nft22,
		artist: artists[0],
		price: 5.01,
		highestBid: 5.11,
	},
	{
		name: "Space Travel",
		img: nft23,
		artist: artists[3],
		price: 81.01,
		highestBid: 53.11,
	},
	{
		name: "Sunset Orbitals",
		img: nft24,
		artist: artists[6],
		price: 62.35,
		highestBid: 45.47,
	},
	{
		name: "Desert Walk",
		img: nft25,
		artist: artists[5],
		price: 12.35,
		highestBid: 21.9,
	},
	{
		name: "Ice Cream Ape 443",
		img: nft26,
		artist: artists[1],
		price: 22.14,
		highestBid: 21.09,
	},
	{
		name: "ColorfulDog 4227",
		img: nft27,
		artist: artists[15],
		price: 13.25,
		highestBid: 20.19,
	},
	{
		name: "Space Tales",
		img: nft6,
		artist: artists[2],
		price: 3.35,
		highestBid: 2.58,
	},
];

export const nftCollection = [
	{
		name: "DSGN Animals",
		img1: aniCol1,
		img2: aniCol2,
		img3: aniCol3,
		value: 1023,
		artist: artists[5],
	},
	{
		name: "Magic Mashrooms",
		img1: mushCol1,
		img2: mushCol2,
		img3: mushCol3,
		value: 900,
		artist: artists[6],
	},
	{
		name: "Disco Machines",
		img1: disCol1,
		img2: disCol2,
		img3: disCol3,
		value: 104,
		artist: artists[12],
	},
	{
		name: "Space Explore",
		img1: NFTspacew,
		img2: nft1,
		img3: nft23,
		value: 234,
		artist: artists[4],
	},
	{
		name: "Happy Robots",
		img1: nft17,
		img2: nft16,
		img3: nft18,
		value: 457,
		artist: artists[14],
	},
	{
		name: "Colorful Dogs",
		img1: nft20,
		img2: nft27,
		img3: aniCol1,
		value: 900,
		artist: artists[19],
	},
	{
		name: "Asto Life",
		img1: nft3,
		img2: nft6,
		img3: nft24,
		value: 1023,
		artist: artists[0],
	},
	{
		name: "The Beyond",
		img1: nft2,
		img2: nft4,
		img3: cat8,
		value: 725,
		artist: artists[8],
	},
	{
		name: "BFC Animals",
		img1: nft9,
		img2: nft10,
		img3: nft26,
		value: 446,
		artist: artists[17],
	},
	{
		name: "Sakura Blossoms",
		img1: nft7,
		img2: nft22,
		img3: nft7,
		value: 876,
		artist: artists[11],
	},
	{
		name: "Planet Tour",
		img1: WalletBg,
		img2: nft1,
		img3: nft25,
		value: 533,
		artist: artists[1],
	},
	{
		name: "Animal Chibi",
		img1: nft10,
		img2: nft11,
		img3: nft5,
		value: 1012,
		artist: artists[10],
	},
];

export const nftCategories = [
	{ name: "Art", image: cat1, icon: PaintBrush },
	{ name: "Collectibles", image: cat2, icon: Swatches },
	{ name: "Music", image: cat3, icon: MusicNote },
	{ name: "Photography", image: cat4, icon: Camera },
	{ name: "Video", image: cat5, icon: VideoCamera },
	{ name: "Utility", image: cat6, icon: MagicWand },
	{ name: "Sport", image: cat7, icon: Basketball },
	{ name: "Virtual Worlds", image: cat8, icon: Planet },
];

export default nftData;
